import Tooltip from "../tooltips/Tooltips";
import {CopyIcon} from "../../assets/icons";
import {useEffect, useState} from "react";
import useReplayableAnimation from "hooks/useReplayableAnimation";

const CopyToClipboardLarge = ({ libelle, text, children, wrap = false }) => {
    const [isCopied, setIsCopied] = useState(false);
    const copiedPop = useReplayableAnimation('motion-safe:animate-pressPop');

    const copyToClipboard = () => {
        navigator.clipboard.writeText(text).then(r => {
            setIsCopied(true);
            copiedPop.play();
        });
    };

    useEffect(() => {
        if (isCopied) {
            setTimeout(() => {
                setIsCopied(false);
            }, 2000);
        }
    }, [isCopied]);

    return (
        <div className="flex justify-between items-center w-full">
            {/* A flex child will not shrink below its content unless min-w-0
                is set: without it a long value pushes the button past the
                right edge and truncate never fires. */}
            <div className={'flex flex-col flex-1 min-w-0'}>
                <div className={''}>{libelle}</div>
                <div
                    className={`my-auto ${wrap ? 'whitespace-normal break-words' : 'truncate'} cursor-pointer text-gray-500 text-sm`}
                >
                    {text}
                </div>
            </div>
            <div
                className={`flex rounded border w-8 h-8 items-center justify-center shrink-0 ml-4 ${copiedPop.animationClassName}`}
                onAnimationEnd={copiedPop.onAnimationEnd}
            >
                <Tooltip
                    text={isCopied ? 'Copié !' : 'Copier dans le presse papier'}
                    placement="right"
                >
                    <button onClick={copyToClipboard}>
                        <CopyIcon wh={20}/>
                    </button>
                </Tooltip>
            </div>
        </div>
    );
}

export default CopyToClipboardLarge
